import { getRole } from "./getRole.js";
const { connectionData, endpoint } = require("./apiConnection");
export const dataAlumnos = async () =>{
    const user = await getRole();
    var response = [];
    if (!user.profesor_id && !user.role === 'teacher' ) {
        response = await connectionData(endpoint, 'alumnos', 'GET')
    } else {
        response = await connectionData(endpoint,'alumnos-teacher/'+user.profesor_id,'GET');
    }
    return response;
} ;
export const dataAlumnosExamenes = async (proximociclo) => connectionData(endpoint, 'alumnos/all/'+proximociclo, 'GET'); 
export const dataAlumno = async (id,ciclo) => connectionData(endpoint,'alumnos/'+ciclo+'/'+id,'GET');
export const addAlumno = async body => connectionData(endpoint,'alumnos/insert/2025','POST',body);
export const updateStatus = async ( id , body ) => connectionData(endpoint,'alumnos/update/status/'+id,'PUT', body );
export const updateReinscription = async ( id , body ) => connectionData(endpoint,'alumnos/update/inscription/'+id,'PUT',body);
export const updateCurso = async ( id , body ) => connectionData(endpoint,'alumnos/update/curso/'+id,'PUT',body);
export const updateAverageEscrito = async () => connectionData(endpoint,'alumnos/tomakeaverageoralall','PUT');
export const updateAverageOral = async () => connectionData(endpoint,'alumnos/tomakeaverageescritoall','PUT');
export const updateAverageGeneral = async () => connectionData(endpoint,'alumnos/tomakeaveragegeneral','PUT');
export const deleteAlumnoById = async (id) => connectionData(endpoint,'alumnos/2025/'+id,'DELETE');
export const updateAlumnoById = async ( id , body ) => connectionData(endpoint,'alumnos/'+id,'PUT',body);
export const toGetCounterAlumnos = async (ciclo) => connectionData(endpoint,'alumnos_counter/'+ciclo,'GET');
export const updateTypeCuota = async (id,ciclo,typeCuota) => connectionData(endpoint,'alumnos-type-cuota/'+id+'/'+ciclo,'PUT', {typeCuota:typeCuota});
export const updateSeguro = async (id,ciclo,seguro) => connectionData(endpoint,'alumnos-seguro/'+id+'/'+ciclo,'PUT', {seguro:seguro});